import {Metric} from 'app_api/projects/metrics/types';

export enum FormulasMenuItemType {
  SavedFormula = `saved_formula`,
  InlineFormula = `inline_formula`,
}

export type FormulasMenuItem =
  | {type: FormulasMenuItemType.InlineFormula; definition: string}
  | {type: FormulasMenuItemType.SavedFormula; id: Metric['id']};
